// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Main Wrapper */
.addflat-main-wrapper {
  min-height: 100vh;
  background-color: #fafafa; /* Whitish background */
}

/* Navbar */
.addflat-navbar {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.addflat-nav-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.addflat-logo-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.addflat-logo-icon {
  font-size: 1.8rem;
  color: #d85200; /* Theme color */
}

.addflat-logo-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
}

.addflat-nav-actions {
  display: flex;
  gap: 1rem;
}

/* Buttons */
.addflat-primary-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #d85200; /* Theme color */
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.addflat-primary-btn:hover {
  background-color: #b84200; /* Darker shade of theme color */
}

.addflat-secondary-btn {
  padding: 0.75rem 1.5rem;
  background-color: #f7fafc;
  color: #1a202c;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.addflat-secondary-btn:hover {
  background-color: #edf2f7;
  border-color: #d85200; /* Theme color accent */
}

.addflat-btn-icon {
  font-size: 1.2rem;
}

/* Hero Section */
.addflat-hero-section {
    background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
    padding: 10px;
    text-align: center;
    border-bottom: 1px solid #e2e8f0;
}

.addflat-hero-content {
  max-width: 1200px;
  margin: 0 auto;
}

.addflat-hero-title {
  font-size: 35px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 2rem;
}

.addflat-search-wrapper {
  max-width: 600px;
  margin: 0 auto;
}

.addflat-search-container {
  position: relative;
  display: flex;
  align-items: center;
}

.addflat-search-icon {
  position: absolute;
  left: 1rem;
  font-size: 1.2rem;
  color: #718096;
}

.addflat-search-input {
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 2.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 1rem;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgb(216 82 0 / 24%);
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.addflat-search-input:focus {
  outline: none;
  border-color: #d85200; /* Theme color */
  box-shadow: 0 0 0 3px rgba(216, 82, 0, 0.2);
}

/* Schemes Section */
.addflat-schemes-section {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;
}

.addflat-schemes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

/* Scheme Card */
.addflat-scheme-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.3s ease;
}

.addflat-scheme-card:hover {
  transform: translateY(-5px);
}

.addflat-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #f7fafc;
}

.addflat-card-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.addflat-building-icon-container {
  cursor: pointer;
}

.addflat-building-icon {
  font-size: 2rem;
  color: #d85200; /* Theme color */
}

.addflat-title-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.addflat-scheme-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
  cursor: pointer;
}

.addflat-status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: capitalize;
}

.addflat-status-progress {
  background-color: #fefcbf;
  color: #d69e2e;
}

.addflat-status-complete {
  background-color: #e6fffa;
  color: #38a169;
}

.addflat-status-inactive {
  background-color: #fed7d7;
  color: #e53e3e;
}

.addflat-status-default {
  background-color: #f7fafc;
  color: #718096;
}

.addflat-delete-button {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #e53e3e;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 0.3s ease;
}

.addflat-delete-button:hover {
  color: #c53030;
}

.addflat-card-body {
  padding: 1rem;
}

.addflat-metrics-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.addflat-metric-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
 justify-content:center;
  border-radius: 6px;
  padding:5px
}

.addflat-metric-booked {
  background-color: #fff5eb; /* Light orange for booked */
}

.addflat-metric-available {
  background-color: #f7fafc; /* Whitish for available */
}

.addflat-metric-icon {
    font-size: 1.5rem;
    color: #c4b0a3;
}

.addflat-metric-data {
  display: flex;
  flex-direction: column;
}

.addflat-metric-value {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
}

.addflat-metric-label {
  font-size: 0.875rem;
  color: #718096;
}

.addflat-details-row {
  display: flex;
  gap: 1rem;
}

.addflat-detail-item {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.addflat-detail-icon {
    font-size: 1.5rem;
    color: #ffc5a2;
}

.addflat-detail-text {
  font-size: 0.875rem;
  color: #1a202c;
}

.addflat-detail-text strong {
  font-weight: 600;
}

.addflat-card-footer {
  padding: 1rem;
  border-top: 1px solid #f7fafc;
}

.addflat-view-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #d85200; /* Theme color */
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.addflat-view-button:hover {
  background-color: #b84200; /* Darker shade of theme color */
}

/* Empty State */
.addflat-empty-state {
  text-align: center;
  padding: 3rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.addflat-empty-icon {
  font-size: 4rem;
  color: #e2e8f0;
  margin-bottom: 1rem;
}

.addflat-empty-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 0.5rem;
}

.addflat-empty-description {
  font-size: 1rem;
  color: #718096;
  margin-bottom: 1rem;
}

.addflat-empty-action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background-color: #d85200; /* Theme color */
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.addflat-empty-action-btn:hover {
  background-color: #b84200; /* Darker shade of theme color */
}

/* Modal */
.addflat-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.addflat-modal-container {
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.addflat-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.addflat-modal-title-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.addflat-modal-icon {
  font-size: 1.5rem;
  color: #d85200; /* Theme color */
}

.addflat-modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
}

.addflat-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #718096;
  cursor: pointer;
}

.addflat-modal-close:hover {
  color: #1a202c;
}

.addflat-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.addflat-form-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.addflat-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.addflat-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #1a202c;
}

.addflat-input,
.addflat-select {
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 1rem;
  color: #1a202c;
  background-color: #ffffff;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.addflat-input:focus,
.addflat-select:focus {
  outline: none;
  border-color: #d85200; /* Theme color */
  box-shadow: 0 0 0 3px rgba(216, 82, 0, 0.2);
}

.addflat-input-row {
  display: flex;
  gap: 1rem;
}

.addflat-form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

/* Responsive Design */
@media (max-width: 768px) {
  .addflat-hero-title {
    font-size: 2rem;
  }

  .addflat-schemes-grid {
    grid-template-columns: 1fr;
  }

  .addflat-metrics-row,
  .addflat-details-row {
    flex-direction: column;
  }

  .addflat-input-row {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .addflat-nav-content {
    flex-direction: column;
    gap: 1rem;
  }

  .addflat-hero-title {
    font-size: 1.5rem;
  }

  .addflat-modal-container {
    margin: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/addflat/AddFlat.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uFAAuF;AACzF;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;IACI,6DAA6D;IAC7D,aAAa;IACb,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,wDAAwD;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,gBAAgB;EACvC,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;CACZ,sBAAsB;EACrB,kBAAkB;EAClB;AACF;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;;EAEE,aAAa;EACb,qBAAqB,EAAE,gBAAgB;EACvC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* General Reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* Main Wrapper */\n.addflat-main-wrapper {\n  min-height: 100vh;\n  background-color: #fafafa; /* Whitish background */\n}\n\n/* Navbar */\n.addflat-navbar {\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  padding: 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.addflat-nav-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.addflat-logo-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.addflat-logo-icon {\n  font-size: 1.8rem;\n  color: #d85200; /* Theme color */\n}\n\n.addflat-logo-text {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.addflat-nav-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n/* Buttons */\n.addflat-primary-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: #d85200; /* Theme color */\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.addflat-primary-btn:hover {\n  background-color: #b84200; /* Darker shade of theme color */\n}\n\n.addflat-secondary-btn {\n  padding: 0.75rem 1.5rem;\n  background-color: #f7fafc;\n  color: #1a202c;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.addflat-secondary-btn:hover {\n  background-color: #edf2f7;\n  border-color: #d85200; /* Theme color accent */\n}\n\n.addflat-btn-icon {\n  font-size: 1.2rem;\n}\n\n/* Hero Section */\n.addflat-hero-section {\n    background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);\n    padding: 10px;\n    text-align: center;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.addflat-hero-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.addflat-hero-title {\n  font-size: 35px;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 2rem;\n}\n\n.addflat-search-wrapper {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.addflat-search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.addflat-search-icon {\n  position: absolute;\n  left: 1rem;\n  font-size: 1.2rem;\n  color: #718096;\n}\n\n.addflat-search-input {\n    width: 100%;\n    padding: 0.75rem 1rem 0.75rem 2.5rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 1rem;\n    background-color: #ffffff;\n    box-shadow: 0 2px 4px rgb(216 82 0 / 24%);\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.addflat-search-input:focus {\n  outline: none;\n  border-color: #d85200; /* Theme color */\n  box-shadow: 0 0 0 3px rgba(216, 82, 0, 0.2);\n}\n\n/* Schemes Section */\n.addflat-schemes-section {\n  max-width: 1200px;\n  margin: 2rem auto;\n  padding: 0 1rem;\n}\n\n.addflat-schemes-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n/* Scheme Card */\n.addflat-scheme-card {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  transition: transform 0.3s ease;\n}\n\n.addflat-scheme-card:hover {\n  transform: translateY(-5px);\n}\n\n.addflat-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.addflat-card-title-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.addflat-building-icon-container {\n  cursor: pointer;\n}\n\n.addflat-building-icon {\n  font-size: 2rem;\n  color: #d85200; /* Theme color */\n}\n\n.addflat-title-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.addflat-scheme-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a202c;\n  cursor: pointer;\n}\n\n.addflat-status-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.addflat-status-progress {\n  background-color: #fefcbf;\n  color: #d69e2e;\n}\n\n.addflat-status-complete {\n  background-color: #e6fffa;\n  color: #38a169;\n}\n\n.addflat-status-inactive {\n  background-color: #fed7d7;\n  color: #e53e3e;\n}\n\n.addflat-status-default {\n  background-color: #f7fafc;\n  color: #718096;\n}\n\n.addflat-delete-button {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: #e53e3e;\n  cursor: pointer;\n  padding: 0.5rem;\n  transition: color 0.3s ease;\n}\n\n.addflat-delete-button:hover {\n  color: #c53030;\n}\n\n.addflat-card-body {\n  padding: 1rem;\n}\n\n.addflat-metrics-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.addflat-metric-item {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n justify-content:center;\n  border-radius: 6px;\n  padding:5px\n}\n\n.addflat-metric-booked {\n  background-color: #fff5eb; /* Light orange for booked */\n}\n\n.addflat-metric-available {\n  background-color: #f7fafc; /* Whitish for available */\n}\n\n.addflat-metric-icon {\n    font-size: 1.5rem;\n    color: #c4b0a3;\n}\n\n.addflat-metric-data {\n  display: flex;\n  flex-direction: column;\n}\n\n.addflat-metric-value {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.addflat-metric-label {\n  font-size: 0.875rem;\n  color: #718096;\n}\n\n.addflat-details-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.addflat-detail-item {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.addflat-detail-icon {\n    font-size: 1.5rem;\n    color: #ffc5a2;\n}\n\n.addflat-detail-text {\n  font-size: 0.875rem;\n  color: #1a202c;\n}\n\n.addflat-detail-text strong {\n  font-weight: 600;\n}\n\n.addflat-card-footer {\n  padding: 1rem;\n  border-top: 1px solid #f7fafc;\n}\n\n.addflat-view-button {\n  width: 100%;\n  padding: 0.75rem;\n  background-color: #d85200; /* Theme color */\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.addflat-view-button:hover {\n  background-color: #b84200; /* Darker shade of theme color */\n}\n\n/* Empty State */\n.addflat-empty-state {\n  text-align: center;\n  padding: 3rem;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.addflat-empty-icon {\n  font-size: 4rem;\n  color: #e2e8f0;\n  margin-bottom: 1rem;\n}\n\n.addflat-empty-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 0.5rem;\n}\n\n.addflat-empty-description {\n  font-size: 1rem;\n  color: #718096;\n  margin-bottom: 1rem;\n}\n\n.addflat-empty-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background-color: #d85200; /* Theme color */\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.addflat-empty-action-btn:hover {\n  background-color: #b84200; /* Darker shade of theme color */\n}\n\n/* Modal */\n.addflat-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.addflat-modal-container {\n  background-color: #ffffff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 500px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.addflat-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.addflat-modal-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.addflat-modal-icon {\n  font-size: 1.5rem;\n  color: #d85200; /* Theme color */\n}\n\n.addflat-modal-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.addflat-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #718096;\n  cursor: pointer;\n}\n\n.addflat-modal-close:hover {\n  color: #1a202c;\n}\n\n.addflat-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.addflat-form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.addflat-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.addflat-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #1a202c;\n}\n\n.addflat-input,\n.addflat-select {\n  padding: 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 1rem;\n  color: #1a202c;\n  background-color: #ffffff;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.addflat-input:focus,\n.addflat-select:focus {\n  outline: none;\n  border-color: #d85200; /* Theme color */\n  box-shadow: 0 0 0 3px rgba(216, 82, 0, 0.2);\n}\n\n.addflat-input-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.addflat-form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .addflat-hero-title {\n    font-size: 2rem;\n  }\n\n  .addflat-schemes-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .addflat-metrics-row,\n  .addflat-details-row {\n    flex-direction: column;\n  }\n\n  .addflat-input-row {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .addflat-nav-content {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .addflat-hero-title {\n    font-size: 1.5rem;\n  }\n\n  .addflat-modal-container {\n    margin: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
